import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const GateIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path d='M14.5 1.5V3.5H8.5V1.5H14.5Z' stroke='currentColor' />
        </>
    ),
})

GateIcon.displayName = 'GateIcon'
